import { Div, Span } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Order } from "../../../../../../Models/Order";


export class MoneyListSummary extends Table
{
    constructor(order: Order)
    {
        super([], [
            ["Wartość koszyka", order.BasketValue + " zł"],
            ["Rzeczywiste wpłaty", order.ReceivedIncome + " zł"],
            ["Docelowa kaucja", order.DesiredDeposit + " zł"],
            ["Wpłacona kaucja", order.ReceivedDeposit + " zł"],
            ["Zwrócona kaucja", order.ReturnedDeposit + " zł"],
            ["Koszty", order.Expenses + " zł"],
            ["Profit", new Span(order.Profit + " zł").Bold()],
        ])
    }
}

// export class MoneyListSummaryForCustomer extends Table
// {
//     constructor(order: Order)
//     {
//         super([], [
//             ["Wartość koszyka", order.BasketValue + " zł"],
//             ["Rzeczywiste wpłaty", order.ReceivedIncome + " zł"],
//             ["Docelowa kaucja", order.DesiredDeposit + " zł"],
//             ["Wpłacona kaucja", order.ReceivedDeposit + " zł"],
//             ["Zwrócona kaucja", order.ReturnedDeposit + " zł"],
//         ])
//     }
// }
